import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { uploadDocument } from "../../../apis/invoicingApis";
import { AddIcon } from "../../../components/Icon";
import { BlobServiceClient } from "@azure/storage-blob";
import { Loader, ErrorSuccessModal } from "../../../components/commons";
import { UploadIcon } from "../../../assets/images";

import "./upload.scss";

interface Props {
  toggleModal: any;
  modal: boolean;
  uploadedUrl: any;
  rIdx: number;
  index: number;
  client_code?: number;
}

const UploadFile = ({
  uploadedUrl,
  rIdx,
  index,
  toggleModal,
  modal,
}: Props) => {
  const blobSasUrl: any = process.env.REACT_APP_BLOB_URL;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  let url = window.location.pathname.split("/");

  let client_code = Number(url[url.length - 1]);
  const containerName = `clientcontainer${client_code}`;

  const containerClient = blobServiceClient.getContainerClient(containerName);

  const [fileData, setFileData] = useState<any>("");
  const [fileNames, setFileNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setModal] = useState(false);
  // const {
  //     uploading,
  //     uploadFileData
  // } = this.props

  const handleDrop = (acceptedFiles: any[string]) => {
    setFileNames(
      acceptedFiles && acceptedFiles.map((file: { name: any }) => file.name)
    );
    setFileData(acceptedFiles);
  };

  const fileUpload = (rIdx: number) => {
    setLoading(true);
    uploadFiles(fileData, rIdx);
  };

  const uploadFiles = async (uploadedFile: any, rIdx: number) => {
    try {
      let resp;
      const promises = [];
      for (const file of uploadedFile) {
        const blockBlobClient = containerClient.getBlockBlobClient(
          new Date().valueOf() +
            "." +
            uploadedFile[0].name.split(".")[
              uploadedFile[0].name.split(".").length - 1
            ]
        );
        //  promises.push(blockBlobClient.uploadBrowserData(file));
        resp = await blockBlobClient.uploadBrowserData(file);
      }
      //  let upload_files = await Promise.all(promises);
      let finalData =
        resp &&
        resp["_response"] &&
        resp["_response"]["request"] &&
        resp["_response"]["request"]["url"];
      if (finalData) {
        uploadedUrl(
          finalData,
          rIdx,
          index,
          uploadedFile[0].name,
          uploadedFile[0].type
        );
      }
      setLoading(false);
      setModal(true);
    } catch (error) {
      setLoading(false);
      setModal(true);
    }
  };

  let uploading = false;
  const maxSize = 10000000; //10mb file size
  return (
    <>
      {/*
            <div className="uploadcsv" style={{ cursor: "auto" }} id={'' + rIdx}>
                {
                    !uploading ?
                        <>
                            <i className="fas fa-cloud-upload-alt"> &nbsp;</i>
                            <Label 
                                htmlFor={`csvuploader-${ rIdx }`}
                                 className="primary" style={{ cursor: "pointer" }}
                            >Upload File</Label>


                            <input
                                type='file'
                                id={`csvuploader-${ rIdx }`}
                                className='d-none'
                                accept=".jpg, .png, .doc, .docx, .xls, .csv,.xlsx, .pdf"
                                onChange={
                                    (e: any) => fileUpload(e, rIdx)}
                            // disabled={uploading}
                            />
                        </>
                        :
                        <>
                            <img src='/img/bulk_upload_img.gif' className='' />
                            <h6>Uploading File -
                                <span className="font-weight-normal">test</span>
                                <span><img src="/admin/img/icons/remove-red.svg" alt="" className="" /></span>
                            </h6>

                        </>
                }
            </div> */}

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>File Uploader</ModalHeader>
        <ModalBody>
          <Dropzone
            accept={
              "image/png, image/gif, application/pdf, image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 	application/msword"
            }
            minSize={0}
            maxSize={maxSize}
            onDrop={handleDrop}
            multiple={false}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragReject,
              fileRejections,
            }) => {
              const isFileTooLarge =
                fileRejections.length > 0 &&
                fileRejections[0]?.file?.size > maxSize;

              return (
                <div
                  {...getRootProps({
                    className: "dropzone drop-area text-center",
                  })}
                >
                  <input {...getInputProps()} />
                  <img src={UploadIcon} />

                  {isDragActive && !isDragReject && (
                    <h4 className="text-center">Drop it like it's hot!</h4>
                  )}

                  {isDragReject && (
                    <h4 className="text-center">
                      File type not accepted, sorry!
                    </h4>
                  )}

                  {!isDragActive && (
                    <h4 className="text-center">
                      Drag'n'drop files, or click to select files
                    </h4>
                  )}
                  <p className="text-muted text-center">
                    Supported formats: images, pdf, excel and doc.{" "}
                  </p>
                  <p className="text-center text-muted ">
                    Single file upload with maximum of 10Mb file size supported.
                  </p>
                  {isFileTooLarge && (
                    <div className="text-danger mt-2">File is too large.</div>
                  )}
                </div>
              );
            }}
          </Dropzone>

          <div>
            <ul className="list-group mt-1">
              {fileNames && fileNames.length
                ? fileNames.map((item) => (
                    <li className="list-group-item active" key={item}>
                      {item}
                    </li>
                  ))
                : null}
            </ul>
          </div>

          {loading && <Loader />}
        </ModalBody>
        <ModalFooter>
          <span className="pointer" onClick={toggleModal}>
            Cancel
          </span>
          {fileNames && fileNames.length ? (
            <Button color="primary" onClick={() => fileUpload(rIdx)}>
              Upload Documents
            </Button>
          ) : null}
        </ModalFooter>
      </Modal>

      {showModal && (
        <ErrorSuccessModal
          type="success"
          isOpen={showModal}
          title="Success"
          message="Document Uploaded Successfully "
          buttonText="OK"
          onPress={() => {
            setModal(false);
            toggleModal();
          }}
          statusCode={200}
        />
      )}
    </>
  );
};

export default UploadFile;
